// extracted by mini-css-extract-plugin
export default {"root":"Equipments_root__i+dhS","root__picture":"Equipments_root__picture__rLUyv","root__item":"Equipments_root__item__D82C-"};